// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ganttToggleBtn {
  margin: 0 0 2rem;
  padding: 0.5rem 2rem 0.5rem 3rem;
  border: 1px solid #ccc;
  background: #fff;
  border-radius: 0;
  position: relative;
  outline: none!important;
}
.ganttToggleBtn:before {
  content: '+';
  position: absolute;
  left: 0.5rem;
  width: 2rem;
  display: block;
}
.ganttToggleBtn--exp:before {
  content: '-';
}
.ganttChartHolder {
  border-bottom: 1px solid #ccc;
  margin: 0 0 20px;
  height: 0;
  overflow: hidden;
}
.ganttChartHolder--exp {
  height: auto;
}
.ganttChartHolder label {
  display: block;
}
.ganttChartHolder input {
  display: block;
  padding-left: 1rem;
  height: 3rem;
  font-size: 1.5rem;
}
.ganttDate {
  display: flex;
  margin: 0 0 2rem;
  align-items: flex-end;
}
.ganttDate__col {
  width: 20rem;
}
.ganttDate__datepicker {
  width: 15rem;
}
.ganttDate .ganttChart__btn {
  padding-top: 4px;
  padding-bottom: 4px;
}
.ganttChart {
  margin: 0 auto;
  overflow-x: hidden;
}
.cp {
  cursor: pointer;
}
.Single--Node {
  stroke-width: 1;
}
.Title {
  font-size: 12px;
  fill: black;
}
.TermType,
.Duration {
  fill: #989898;
  font-size: 11px;
  text-transform: uppercase;
  font-weight: 600;
}
.second-title {
  font-size: 12px;
}
.date-line {
  stroke: #f5f5f5;
  stroke-width: 1;
}
.Date-Block,
.Date-Block-Outline {
  fill: #fff;
  stroke: #ccc;
}
.start-lines,
.end-lines {
  stroke-width: 1;
}
/*
.gantt-wrapper{
display: flex;
flex-direction: column;
border: 1px solid #767676;
border-radius: 5px 5px 0px 0px;
height: 100vh;
}
*/
.chart {
  overflow: auto;
}
.gantt-top {
  display: flex;
  justify-content: space-around;
  align-items: center;
  height: 150px;
}
.range-select p {
  margin-left: 20px;
}
.gantt-top p,
.gantt-top select,
.gantt-top .range-select,
.gantt-top button {
  display: inline-block;
}
.empty_message_block {
  border: #ccc;
  border-radius: 4px;
}
.CurrentDay-Area {
  stroke: #777;
  stroke-dasharray: 2;
}
.startDay-Area {
  stroke: black;
}
.endDay-Area {
  stroke: black;
}
`, "",{"version":3,"sources":["webpack://./app/styles/gantt.less"],"names":[],"mappings":"AAAA;EACE,gBAAA;EACA,gCAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,kBAAA;EASA,uBAAA;AAPF;AADE;EACE,YAAA;EACA,kBAAA;EACA,YAAA;EACA,WAAA;EACA,cAAA;AAGJ;AACE;EACE,YAAA;AACJ;AAGA;EACE,6BAAA;EACA,gBAAA;EAEA,SAAA;EACA,gBAAA;AAFF;AAGE;EACE,YAAA;AADJ;AANA;EAUI,cAAA;AADJ;AATA;EAaI,cAAA;EACA,kBAAA;EACA,YAAA;EACA,iBAAA;AADJ;AAKA;EACI,aAAA;EACA,gBAAA;EACA,qBAAA;AAHJ;AAKI;EACI,YAAA;AAHR;AAMI;EACI,YAAA;AAJR;AANA;EAcQ,gBAAA;EACA,mBAAA;AALR;AAUA;EACE,cAAA;EACA,kBAAA;AARF;AAWA;EACE,eAAA;AATF;AAWA;EACE,eAAA;AATF;AAYA;EACE,eAAA;EACA,WAAA;AAVF;AAeA;;EACE,aAAA;EACA,eAAA;EACA,yBAAA;EACA,gBAAA;AAZF;AAcA;EACE,eAAA;AAZF;AAeA;EACE,eAAA;EACA,eAAA;AAbF;AAeA;;EACE,UAAA;EACA,YAAA;AAZF;AAcA;;EACE,eAAA;AAXF;AACA;;;;;;;;CAQC;AAeD;EACE,cAAA;AAbF;AAgBA;EACE,aAAA;EACA,6BAAA;EACA,mBAAA;EACA,aAAA;AAdF;AAiBA;EACE,iBAAA;AAfF;AAkBA;;;;EAIE,qBAAA;AAhBF;AAkBA;EACE,YAAA;EACA,kBAAA;AAhBF;AAoBA;EACE,YAAA;EACA,mBAAA;AAlBF;AAsBA;EACE,aAAA;AApBF;AAuBA;EACE,aAAA;AArBF","sourcesContent":[".ganttToggleBtn{\n  margin: 0 0 2rem;\n  padding: .5rem 2rem .5rem 3rem;\n  border: 1px solid #ccc;\n  background: #fff;\n  border-radius: 0;\n  position: relative;\n  &:before{\n    content: '+';\n    position: absolute;\n    left: .5rem;\n    width: 2rem;\n    display: block;\n  }\n\n  outline: none!important;\n  &--exp:before{\n    content: '-';\n  }\n}\n\n.ganttChartHolder{\n  border-bottom: 1px solid #ccc;\n  margin: 0 0 20px;\n  // padding-bottom: 1rem;\n  height: 0;\n  overflow: hidden;\n  &--exp{\n    height: auto;\n  }\n  label{\n    display: block;\n  }\n  input{\n    display: block;\n    padding-left: 1rem;\n    height: 3rem;\n    font-size: 1.5rem;\n  }\n}\n\n.ganttDate {\n    display: flex;\n    margin: 0 0 2rem;\n    align-items: flex-end;\n\n    &__col {\n        width: 20rem;\n    }\n\n    &__datepicker {\n        width: 15rem;\n    }\n\n    .ganttChart__btn {\n        padding-top: 4px;\n        padding-bottom: 4px;\n    }\n}\n\n\n.ganttChart {\n  margin: 0 auto;\n  overflow-x: hidden;\n}\n\n.cp {\n  cursor: pointer;\n}\n.Single--Node {\n  stroke-width: 1;\n}\n\n.Title {\n  font-size: 12px;\n  fill: black;\n  // text-shadow: 0 0 2px #000;\n}\n\n\n.TermType, .Duration {\n  fill: #989898;\n  font-size: 11px;\n  text-transform: uppercase;\n  font-weight: 600;\n}\n.second-title {\n  font-size: 12px;\n}\n\n.date-line {\n  stroke: #f5f5f5;\n  stroke-width: 1;\n}\n.Date-Block, .Date-Block-Outline {\n  fill: #fff;\n  stroke: #ccc;\n}\n.start-lines, .end-lines {\n  stroke-width: 1;\n}\n\n/*\n.gantt-wrapper{\ndisplay: flex;\nflex-direction: column;\nborder: 1px solid #767676;\nborder-radius: 5px 5px 0px 0px;\nheight: 100vh;\n}\n*/\n\n.chart{\n  overflow: auto;\n}\n\n.gantt-top{\n  display: flex;\n  justify-content: space-around;\n  align-items: center;\n  height: 150px;\n}\n\n.range-select p{\n  margin-left: 20px;\n}\n\n.gantt-top p,\n.gantt-top select,\n.gantt-top .range-select,\n.gantt-top button{\n  display: inline-block;\n}\n.empty_message_block {\n  border: #ccc;\n  border-radius: 4px;\n}\n\n\n.CurrentDay-Area {\n  stroke: #777;\n  stroke-dasharray: 2;\n}\n\n\n.startDay-Area{\n  stroke: black;\n}\n\n.endDay-Area{\n  stroke: black;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
